export default "__VITE_ASSET__rEvtgy_U__";